import { render, staticRenderFns } from "./loginHome.vue?vue&type=template&id=5db60a54&scoped=true&"
import script from "./loginHome.vue?vue&type=script&lang=js&"
export * from "./loginHome.vue?vue&type=script&lang=js&"
import style0 from "./loginHome.vue?vue&type=style&index=0&id=5db60a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db60a54",
  null
  
)

export default component.exports